/**
 * LAN SUA CHU DANG CO HIEU LUC - suy ra tu DANH SACH LENH cho lop chinh sua ve.
 *
 * Tach rieng khoi EditedTextLayer.tsx (co JSX) de bo test node:test import duoc:
 * trinh chay thu strip type cho .ts nhung khong xu ly JSX trong .tsx.
 */
import type { EditCommand } from '@pdfeditor/types';

/**
 * Mot lan sua DANG CO HIEU LUC, cho lop chinh sua (EditedTextLayer) ve de len.
 *
 * Suy ra tu DANH SACH LENH (nguon chan ly), KHONG tu ban do editedText dồn: ban
 * do do dat `blockId -> newText` moi lan chieu lenh va GIU LAI ke ca khi lenh bi
 * hoan tac (undo chieu lenh nghich, dat lai chu goc nhung khong xoa khoa). Nen
 * `text === chu goc` khong phan biet duoc "da Ctrl+Z" voi "chi doi phong / dam /
 * nghieng ma giu nguyen chu". Danh sach lenh thi sau undo KHONG con lenh do - nen
 * moi muc suy ra o day dung la mot lan sua that su dang hien.
 */
export interface EditedItem {
  /** Van ban moi. BANG chu goc khi lan sua chi doi kieu chu chu khong doi chu. */
  text: string;
  /** Ma ho font nguoi dung chon. Bo trong = phong mac dinh (noto-sans). */
  fontFamily?: string | undefined;
  /** Dam / nghieng - phai ve dung mat chu SE DUOC NHUNG, khong chi mac dinh. */
  bold: boolean;
  italic: boolean;
}

/**
 * Suy ra cac lan sua dang co hieu luc tu DANH SACH LENH.
 *
 * PHAI la danh sach lenh (activeCommands), khong phai ban do editedText dồn: xem
 * ghi chu o EditedItem. Sau Ctrl+Z lenh khong con trong danh sach nen khong ve
 * nham; con lan sua chi doi phong / dam / nghieng (giu nguyen chu) VAN co mat
 * nen ve dung kieu ngay - khong phai bam Luu moi thay. Lenh cuoi cung cho moi
 * blockId thang: mot o sua nhieu lan chi ve trang thai moi nhat.
 *
 * Chi lay 'text.replace'; cac lenh chu thich / trang / anh khong ve o lop nay.
 */
export function editedItemsFromCommands(
  commands: readonly EditCommand[],
): Map<string, EditedItem> {
  const map = new Map<string, EditedItem>();
  for (const command of commands) {
    if (command.kind !== 'text.replace') continue;
    map.set(command.blockId, {
      text: command.newText,
      ...(command.fontFamily ? { fontFamily: command.fontFamily } : {}),
      bold: command.bold === true,
      italic: command.italic === true,
    });
  }
  return map;
}

/**
 * KHOA cua so do dat chu (EditRenderHint) theo NOI DUNG cua mot lenh text.replace.
 *
 * Vi sao khong khoa theo blockId: mot o co the sua NHIEU LAN thanh nhieu muc lich
 * su rieng, moi lan cho ra mot so do khac (hop che, co chu, so dong). Neu cache
 * hint theo blockId thi lan sua sau ghi de lan truoc, va sau Ctrl+Z - luc lop ve
 * da lui ve chu cua lan TRUOC - hint van la cua lan SAU: ban xem truoc ve chu cu
 * trong hop che / co chu cua lan sau (loi "ban xem truoc noi doi" do review doi
 * khang bat duoc). Khoa theo chinh noi dung lenh thi undo / redo / gop lenh deu
 * tu dung: lenh dang co hieu luc tra dung hint da tinh cho no.
 *
 * So do hint la mot ham cua (blockId, chu moi, can le, dam, nghieng, phong, co
 * chu) tren mot tai lieu co dinh - dung nhung truong quyet dinh bo cuc lam khoa.
 */
export function hintKey(command: Extract<EditCommand, { kind: 'text.replace' }>): string {
  return [
    command.blockId,
    command.newText,
    command.align ?? '',
    command.bold ? '1' : '0',
    command.italic ? '1' : '0',
    command.fontFamily ?? '',
    command.fontSizePt ?? '',
  ].join(' ');
}
